export const LIB_VERSION = '1.306.0'; // autogenerated
